import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SvgIcon, SvgFill } from '@chegg-ui/svg-icon';
var TwitterCircleDark = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement(SvgFill, {
    svgColor: "#fff",
    d: "M0 0h44v44H0z"
  }), /*#__PURE__*/React.createElement(SvgFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 44c12.15 0 22-9.85 22-22S34.15 0 22 0 0 9.85 0 22s9.85 22 22 22Zm12.744-26.677C34.744 25.996 28.14 36 16.067 36A18.625 18.625 0 0 1 6 33.051a13.162 13.162 0 0 0 9.723-2.716 6.578 6.578 0 0 1-6.13-4.562c.983.19 1.996.152 2.962-.113a6.562 6.562 0 0 1-5.268-6.437v-.081a6.573 6.573 0 0 0 2.975.819A6.572 6.572 0 0 1 8.23 11.2a18.646 18.646 0 0 0 13.528 6.853 6.573 6.573 0 0 1 11.192-5.986c1.47-.29 2.88-.829 4.168-1.593a6.6 6.6 0 0 1-2.887 3.63A12.943 12.943 0 0 0 38 13.076a13.331 13.331 0 0 1-3.274 3.398c.012.282.018.569.018.85Z",
    svgColor: "#302C41"
  }));
});
TwitterCircleDark.displayName = 'TwitterCircleDark';
TwitterCircleDark.defaultProps = {
  'aria-label': 'TwitterCircleDark'
};
export default TwitterCircleDark;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg-ui/horizon-icons/dist/esm/icons/Logo/TwitterCircleDark.js
// module id = 3588
// module chunks = 11